// extracted by mini-css-extract-plugin
export var black = "_3f-6";
export var brand = "_3f-1";
export var ddefault = "_3f-0";
export var error = "_3f-3";
export var gray = "_3f-2";
export var highContrast = "_3f-8";
export var outline = "_3f-7";
export var success = "_3f-5";
export var warning = "_3f-4";